let filterSection = document.getElementById("main-collection-filters");
let filterIcon = document.getElementById("filter-icon");

const setFilterIcon = (state) => {
  if (!filterIcon) return;
  if (state === "open") {
    // filters are open, set icon as 'x' mark
    filterIcon.setAttribute("d", "M6 18L18 6M6 6l12 12");
  } else if (state === "close") {
    // filters are closed, set icon as filter bars
    filterIcon.setAttribute(
      "d",
      "M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
    );
  }
};

// click handler to hide/show the filter options
const toggleFilters = () => {
  if (!filterSection || !filterIcon) return;
  if (filterSection.style.display === "none") {
    filterSection.style.display = "block";
    setFilterIcon('open');
  } else {
    filterSection.style.display = "none";
    setFilterIcon('close');
  }
};

const debounceFunc = (func, delay = 200) => {
  let timeoutID;
  return (...args) => {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

// forcing the filter menu to show based on window width.
// called once initially, then on resizes of the window (debounced)
const handleWidthChange = () => {
  if (!filterSection || !filterIcon) return;
  if (window.innerWidth < 750) {
    filterSection.style.display = "block";
    filterIcon.style.display = "none";
  } else {
    filterSection.style.display = "none";
    filterIcon.style.display = "block";
    setFilterIcon('close');
  }
};

const debouncedWidthChange = debounceFunc(handleWidthChange);

const attachWidthHandler = () => {
  handleWidthChange();
  window.addEventListener("resize", debouncedWidthChange);
};

const removeWidthHandler = () => {
  window.removeEventListener("resize", debouncedWidthChange);
};

document.addEventListener("DOMContentLoaded", () => {
  filterSection = document.getElementById("main-collection-filters");
  filterIcon = document.getElementById("filter-icon");
  attachWidthHandler();
  window.addEventListener("beforeunload", removeWidthHandler);
});
